import type { Router } from 'expo-router';

/**
 * Navigate back if there's a history entry, otherwise `replace` to a sensible
 * fallback. Fixes the cryptic "The action 'GO_BACK' was not handled by any
 * navigator" error you get on web when a screen is the initial route or when
 * `router.back()` is called after `router.replace()` cleared the stack.
 */
export function goBackOrTo(router: Router, fallback: string): void {
  if (router.canGoBack()) {
    router.back();
    return;
  }
  router.replace(fallback as never);
}

/**
 * Unconditionally navigate to a target route and dismiss any pushed
 * screens above it. Used by the Home / Schedule shortcuts on detail
 * pages — without `dismissAll()` the back button on the destination
 * would still walk through every task detail the user had stacked,
 * which is the exact loop the shortcuts exist to escape.
 *
 * `dismissAll` is optional (older Expo Router versions don't have it),
 * so we chain through optional chaining and follow with `replace` as
 * the canonical post-dismiss landing.
 */
export function goTo(router: Router, href: string): void {
  router.dismissAll?.();
  router.replace(href as never);
}
